import config from '../config'
import useAuthStore from '../stores/authStore'

const handleTokenExpiration = () => {
  const { logout, setSessionExpired } = useAuthStore.getState()
  logout()
  setSessionExpired(true)
  // Force navigation to auth page
  // window.location.href = '/auth'
}

const api = {
  get: async (endpoint) => {
    const token = useAuthStore.getState().token
    const response = await fetch(`${config.apiBaseUrl}${endpoint}`, {
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json'
      }
    })
    
    if (response.status === 400) {
      const error = await response.json()
      if (error.message === 'Invalid Token') {
        handleTokenExpiration()
      }
      throw new Error(error.message)
    }
    
    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.message)
    }
    
    return response.json()
  },
  
  post: async (endpoint, data) => {
    const token = useAuthStore.getState().token
    const response = await fetch(`${config.apiBaseUrl}${endpoint}`, {
      method: 'POST',
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    
    if (response.status === 400) {
      console.log('400 error')
      const error = await response.json()
      if (error.message === 'Invalid Token') {
        console.log('Invalid Token')
        handleTokenExpiration()
      }
      throw new Error(error.message)
    }
    
    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.message)
    }
    
    return response.json()
  }
}

export default api 